module.exports = __webpack_public_path__ + "static/media/15-fetch-09_16_2020.f0cac340.jpg";